import { jsx, css } from '@emotion/react';
import styled from '@emotion/styled';

import Link from './oc-link';
import WrapperLink from './oc-wrapper-link';
import Theme from '../../themes/index';

const StyledLink = styled(WrapperLink)`
  display: inline-flex;
  text-decoration: none;
  justify-content: space-between;
  align-items: center;

  .wrapper-link:hover &,
  &:hover {
    text-decoration: none !important;
    color: ${Theme.colors.brand};
    cursor: pointer;
  }

  .background-black & {
    color: white;

    .wrapper-link:hover &,
    &:hover {
      color: ${Theme.colors.sharedGrey}
    }
  }
`;

const Chevron = styled.span`
  display: inline-flex;
  align-self: center;
  margin-left: 10px;
  transition: margin 0.35s;
  text-decoration: none;

  .wrapper-link:hover &,
  a:hover > & {
    margin-left: 25px;
    color: ${Theme.colors.brand};

    .background-black & {
      color: ${Theme.colors.sharedGrey}
    }
  }

  &:after {
    font-family: 'icomoon';
    content: '\\00E608';
    position: relative;
  }
`;

// eslint-disable-next-line react/prop-types
const ChevronLink = ({ url, children, ariaLabel = 'Learn More', ...props }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <StyledLink aria-label={ariaLabel} className="chevron-link" url={url} element="span" {...props}>
    {children} <Chevron />
  </StyledLink>
);

export default ChevronLink;
